/* eslint-disable jsx-a11y/anchor-is-valid */
import {
  createGooglePolygons,
  parseRequestCoordsToPolygon,
} from "../../../utils/map";
import { useEffect, useMemo, useState } from "react";
import { AbsencesFormData } from "../../Absences/Types/Absences.type";
import { CreateAbsencesRequestService } from "../../../services/Absences/Absences.type";
import { DatePicker } from "../../../components/others/DatePicker";
import FileUpload from "../../../components/others/FileUploader/FileUploader";
import { GetDangerZonesListResponse } from "../../../services/DangerZones/DangerZones.type";
import { IndividualEmployeeResponseService } from "../../../services/Company/Employee.type";
import { Input } from "../../../components/core/Input";
import { InputNumber } from "../../../components/others/InputNumber";
import LavorisService from "../../../services/LavorisService";
import { PrimaryButton } from "../../../components/others/ButtonPrimary";
import Select from "../../../components/others/Select/Select";
import { SelectedFiles } from "../../../components/others/FileUploader/FileUploader.types";
import StyledWrapper from "./style";
import Textarea from "../../../components/others/Textarea/Textarea";
import ToggleSwitch from "../../../components/others/Toggle/ToggleSwitch";
import { useForm } from "react-hook-form";
import { useSearchParams } from "react-router-dom";
import { validateAddress } from "./utils";
import SearchSelectFetch from "../../../components/others/SearchFetch";
import { useModal } from "../../../hooks";
import AddressAutocomplete from "../../../components/others/MapsAutocomplete";
import { useSelector } from "react-redux";
import { RootState } from "../../../store/combineReducer";
import { PhoneNumber } from "../../../utils/phoneNumber";
import moment from "moment";
import { useAlert } from "../../../hooks/useAlert";
import InputRadio from "../../../components/others/InputRadio/InputRadio";
import EditEmployeeModal from "../editEmployee";
import UpdateParcialEmployeeData from "./updateParcialEmployeeData";

const UPDATE_EMPLOYEE_DATA = 'updateEmployeeDataModal';
const SUCCESS = 'succesPetition';
type TProps = {
  refreshFunction: Function;
};

export default function RequestAbsencesForm({ refreshFunction }: TProps) {
  const {
    register,
    handleSubmit,
    reset,
    formState: { errors },
    setValue,
    setError,
    clearErrors,
    control,
    watch,
  } = useForm<AbsencesFormData>({
    mode: "all",
  });


  const employee = watch("employee");
  const [isNotAtHome, setIsNotAtHome] = useState<string | boolean>();
  const chosenCompany = useSelector((state: RootState) => state.user.currentCompany || state.user.companies[0]);
  const chosenCompanyManagerId = chosenCompany?.managerId;

  // Lista de compañías permitidas para Lavoris Gestiona
  const allowedCompanies = ['9001', '1828', '11037', '1', '4643', '3987', '11881', '11890'];
  const isAllowedToGestionaLavoris = allowedCompanies.includes(chosenCompanyManagerId);

  const selectOptions = [
    { name: "Control a Domicilio", value: "Visita a Domicilio" },
    { name: "Telemedicina", value: "Videollamada" },
    ...(isAllowedToGestionaLavoris
      ? [{ name: "AI - Ausentismo Inteligente", value: "Define Lavoris" }]
      : [])
  ];
  const LavorisInstance = LavorisService.getInstance();
  const [searchParams] = useSearchParams();
  const [isReady, setIsReady] = useState(false);
  const [isLoading, setIsLoading] = useState(false);
  const { showAlert } = useAlert()

  const [employees, setEmployees] = useState<IndividualEmployeeResponseService[]>([]);

  const [dangerZones, setDangerZones] = useState<GetDangerZonesListResponse>([],);
  const [selectedEmployee, setSelectedEmployee] = useState<IndividualEmployeeResponseService | null | undefined>();
  const [selectedFiles, setSelectedFiles] = useState<SelectedFiles | null>(null,);
  const [lat, setLat] = useState("");
  const [lng, setLng] = useState("");

  //useModal
  const { openModal, closeModal, isActive } = useModal();

  // const getAllZonesList = async () => {
  //   try {
  //     const dangerZones =
  //       await LavorisInstance.DangerZones.GetAllDangerZonesList();
  //     setDangerZones(dangerZones);
  //   } catch (e: any) {
  //     console.log(e);
  //   }
  // };

  const zones = useMemo(
    () =>
      dangerZones
        .map(({ polygon, name }) => ({
          name,
          polygon: parseRequestCoordsToPolygon(polygon),
        }))
        .map(createGooglePolygons),
    [dangerZones],
  );

  const getAllEmployeesCall = async () => {
    try {
      const employees =
        await LavorisInstance.CompanyServices.getEmployeesOfCurrentCompany(
          chosenCompany.id,
        );
      if (employees?.length > 0) {
        const tempList = [];
        for (let employee of employees) {

          tempList.push({
            name: employee.name,
            id: employee.id,
            DNI: employee.DNI,
            lat: employee.lat,
            lng: employee.lng,
            supplementaryReference: employee.supplementaryReference,
            fullAddress: employee.fullAddress,
          });
        }
        //console.log('EMPLEADOS', employees)
        setEmployees(employees);

        return tempList;
      }
    } catch (e: any) {
      console.log(e);
      return [] as {
        name: string;
        id: string;
        DNI: string;
        lat: string;
        lng: string;
      }[];
    }
    return [] as {
      name: string;
      id: string;
      DNI: string;
      lat: string;
      lng: string;
    }[];
  };

  // useEffect(() => {
  //   setSelectedEmployee(undefined);
  // }, []);

  // useEffect(() => {
  //   const getData = async () => {
  //     reset();
  //     await getAllEmployeesCall();
  //     await getAllZonesList();
  //     setIsReady(true);
  //   };
  //   getData();
  //   // eslint-disable-next-line react-hooks/exhaustive-deps
  // }, []);
  const handleCloseUpdatePhoneNumberModal = async () => {
    closeModal(UPDATE_EMPLOYEE_DATA);
    if (selectedEmployee) {
      setSelectedEmployee(null);
      reset({ employee: undefined })
      await getAllEmployeesCall(); // Vuelve a obtener la lista de empleados          
    }
  };



  const handleClose = (shouldOpenDangerousAlert?: boolean, type?: string) => {
    if (
      (shouldOpenDangerousAlert && type === "Visita a Domicilio") ||
      (shouldOpenDangerousAlert && type === "Define Lavoris")
    ) {
      openModal("modalAlertaZonaPeligrosa");
    } else {
      closeModal('modalSolicitarAusentismo')
      refreshFunction();
    }
  };

  const getAddressComponentByType = (
    type: string,
    locationObj: google.maps.places.PlaceResult,
    fullAdrss: boolean = true,
  ): string | null => {
    const addressComponents = locationObj.address_components;
    if (fullAdrss) {
      const adrsName = locationObj.formatted_address || ""
      return adrsName
    }
    if (addressComponents) {
      for (let i = 0; i < addressComponents.length; i++) {
        const component = addressComponents[i];
        if (component.types.includes(type)) {
          return component.long_name;
        }
      }
    }
    return null;
  };

  const handleSelectAddress = (
    addressObject: google.maps.places.PlaceResult,
  ) => {

    // Obtener los componentes de dirección
    const streetName = getAddressComponentByType("route", addressObject, false) || "";
    const streetNumber = getAddressComponentByType("street_number", addressObject, false) || "";
    const neighborhood = getAddressComponentByType("neighborhood", addressObject, false) || "";
    const locality = getAddressComponentByType("locality", addressObject, false) || "";
    const province = getAddressComponentByType("administrative_area_level_1", addressObject, false) || "";


    // Construir la dirección
    let address = "";

    // Concatenar calle y número
    if (streetName || streetNumber) {
      address += `${streetName} ${streetNumber}, `;
    }

    // Agregar barrio si existe
    if (neighborhood) {
      address += `${neighborhood}, `;
    }

    // Agregar localidad si existe
    if (locality) {
      address += `${locality}, `;
    }

    // Agregar provincia si existe
    if (province) {
      address += `${province}, `;
    }

    // Guardar la dirección en el estado o donde sea necesario
    setValue("address", address.trim());

    if (
      addressObject &&
      addressObject.geometry &&
      addressObject.geometry.location
    ) {
      setLat(addressObject.geometry.location.lat().toString() || "");
      setLng(addressObject.geometry.location.lng().toString() || "");
    }
  };

  const handleEmployeeSelect = (employee: any) => {
    const chosenEmployee = employees.find((e) => e.id === employee.id);
    setSelectedEmployee(chosenEmployee);
  };

  const updateUploadedFiles = (files: File[]) =>
    setSelectedFiles({ ...selectedFiles, profileImages: files });

  const uploadCertificate = async (id: string, selectedFile: File) => {
    await LavorisInstance.Absences.AddAbsenceCertificate(
      { certificate: selectedFile },
      id,
    ).catch((e: any) => console.log(e));
  };




  const tipo = watch('type')

  useEffect(() => {
    if (tipo === "Consulta en Lavoris") {
      showAlert('Si necesita un ausentismo en consultorio solicitelo desde Control en Consultorio')
    }
  }, [tipo === "Consulta en Lavoris"])

  const clearInvalidAddressErrors = () => {
    const list: Array<keyof AbsencesFormData> = [];
    errors?.address?.type === "invalid_address" && list.push("address");
    errors?.neighborhood?.type === "invalid_address" && list.push("neighborhood");
    errors?.city?.type === "invalid_address" && list.push("city");
    errors?.province?.type === "invalid_address" && list.push("province");
    clearErrors(list);


  };




  // OnSubmit
  const onSubmit = async (data: AbsencesFormData) => {
    setIsLoading(true);
    try {
      const addressValues = await validateAddress(
        data,
        zones,
        setError,
        employee.supplementaryReference || "",
        selectedEmployee,
      );
      const { isValid } = addressValues;
      if (!isValid) return null;

      const { isDangerous, shouldOpenDangerousAlert, coordinates } =
        addressValues;
      const today = moment().format('YYYY-MM-DD');
      const fullAddress = `${selectedEmployee?.fullAddress} ${selectedEmployee?.supplementaryReference ? `, (${selectedEmployee.supplementaryReference})` : ""}  `
      //SUBMIT TURN DATA TO CREATE AN ABSENCES TURN FOR EMPLOYEE
      let dataToSubmit: CreateAbsencesRequestService = {
        employeeId: data.employee.id,
        type: data.type,
        observations: data.observations,
        presumedDiagnosis: data.presumedDiagnosis,
        familyMemberInfo: data.familyMemberInfo,
        dangerZone: isDangerous,
        presentsCertificate: data.presentsCertificate,
        profesionalName: data.presentsCertificate ? data.profesionalName : null,
        profesionalRegistration: data.presentsCertificate
          ? data.profesionalRegistration
          : null,
        certificateJustifiedDays: data.presentsCertificate
          ? data.certificateJustifiedDays
          : null,
        certificateDate: data.presentsCertificate
          ? moment(data.certificateDate).format("DD/MM/YYYY")
          : null,


        fullAddress: fullAddress.trim(),
        not_at_home: data.not_at_home === 'Si' ? true : false,
        alternative_adrs: data.not_at_home === 'Si' ? data.address : null,
        fecha_carpeta_medica: today,

        coordinates: data.not_at_home === 'Si'
          ? {
            latitude: coordinates.latitude,
            longitude: coordinates.longitude,
          }
          : {
            latitude: selectedEmployee?.lat,
            longitude: selectedEmployee?.lng,
          },
      };

      const serviceUrl = tipo === 'Define Lavoris' ?
        LavorisInstance.AbsencesServices.createDecideLavorisRequest(dataToSubmit)
        : LavorisInstance.AbsencesServices.CreateAbsencesService(dataToSubmit);

      const resp = await serviceUrl;
      if (resp && resp?.id !== "" && !!selectedFiles?.profileImages.length) {
        await uploadCertificate(resp?.id, selectedFiles.profileImages[0]);
      }


      handleClose(shouldOpenDangerousAlert, data.type);
      closeModal("modalSolicitarAusentismo");
      refreshFunction();
      openModal(SUCCESS);
    } catch (err: any) {
      console.log(err);
      const errorMessage = err?.response.data.message;
      if (
        errorMessage[0] === "coordinates.latitude should not be empty" &&
        errorMessage[1] === "coordinates.longitude should not be empty"
      ) {
        openModal("modalCoordinatesError");
      }

      showAlert({title: 'No se pudo crear la solicitud', subtitle: errorMessage});
    } finally {
      setIsLoading(false);
    }
  };


  const returnAdress = (employee: any) => {
    const fullAddress = employee?.fullAddress || "N/A";
    const supplementaryReference = employee?.supplementaryReference
      ? `, (${employee.supplementaryReference})`
      : "";

    return `${fullAddress}${supplementaryReference}`;
  };




  return (
    <div className="max-w-3xl ">
      <form onSubmit={handleSubmit(onSubmit)}>
        <StyledWrapper.FormContainer>
          <Select
            fieldName="type"
            label="Modalidad de ausentismo"
            register={register}
            required
            error={errors?.type}
            disableFirstOption
            options={selectOptions}
            styles="rounded w-full h-[50px]"
          />
          <SearchSelectFetch
            control={control}
            name="employee"
            label="Buscar empleado"
            inputStyles="rounded w-full h-[50px]"
            fetchOptions={getAllEmployeesCall}
            onSelected={handleEmployeeSelect}
            propertyLabel={"name"}
            propertyLabelDNI={"DNI"}
            required
          />
          <div className="flex gap-4 max-w-lg">
            {selectedEmployee ? (
              <div className="flex flex-col gap-4">
                <div className="flex flex-col gap-4 justify-start align-middle">

                  <div className="flex flex-wrap gap-2 align-middle">
                    <p className="font-bold w-20">Paciente: </p>
                    <p>{selectedEmployee?.name || "N/A"}</p>
                  </div>

                  <div className="flex flex-wrap gap-3 align-middle">
                    <p className="font-bold w-20">DNI: </p>
                    <p>{selectedEmployee?.DNI || "N/A"}</p>
                  </div>

                  <div className="flex gap-3 align-middle">
                    <p className="font-bold w-20">Domicilio: </p>
                    <p className="w-[100%]">
                      {returnAdress(selectedEmployee)}
                    </p>
                  </div>

                  <div className="flex flex-wrap gap-3 align-middle">
                    <p className="font-bold w-20">Teléfono: </p>
                    <p className="">{PhoneNumber(selectedEmployee?.phoneNumber) || "N/A"} </p>
                  </div>
                </div>
                <div className="flex justify-center align-middle">
                  <button
                    type="button"
                    onClick={() => openModal(UPDATE_EMPLOYEE_DATA, selectedEmployee.id)}
                    className="my-2 mx-auto p-2 bg-blue-800 text-white w-fit rounded-md">
                    Editar datos
                  </button>
                </div>
                {(tipo === "Define Lavoris" || tipo === "Videollamada") ? (
                  <div className="text-black p-3 rounded-lg text-sm font-bold w-fit bg-blue-300">
                    Seleccionaste la <strong>opción</strong> {tipo === "Define Lavoris" ? "Lavoris Gestiona" : "Telemedicina"}. Verifica que el número de celular del empleado sea correcto, caso contrario modificar previo a realizar la solicitud.
                  </div>
                )
                  :
                  <div className="text-black p-3 rounded-lg text-sm font-bold w-fit bg-blue-300">
                    Seleccionaste la <strong>opción</strong> Control a domicilio. Verifica que el número de celular y la dirección del empleado sea correcto, caso contrario modificar previo a realizar la solicitud.
                  </div>
                }
              </div>
            ) : null}
          </div>
          <>
            <Input
              type="text"
              label="Diagnóstico presunto"
              fieldName="presumedDiagnosis"
              register={register}
              required
              error={errors?.presumedDiagnosis}
            />

            <Textarea
              fieldName="observations"
              label="Observaciones"
              register={register}
              error={errors?.observations}
              rows={4}
              styles="rounded w-full"
            />
            <ToggleSwitch
              label="Empleado presenta certificado médico."
              onChange={(e) => {
                setValue("presentsCertificate", e);
                // setValue("certificateDate", undefined);
                // setValue("certificateJustifiedDays", undefined);
              }}
            >
              <Input
                type="text"
                label="Nombre del profesional"
                fieldName="profesionalName"
                register={register}
                required
                error={errors?.profesionalName}
              />
              <Input
                type="text"
                label="Matrícula del profesional"
                fieldName="profesionalRegistration"
                register={register}
                required
                error={errors?.profesionalRegistration}
              />

              <DatePicker
                minDate={1}
                shouldDisableDate={(date: Date) => {
                  return date.getTime() > Date.now();
                }}
                label="Fecha del Certificado"
                fieldName="certificateDate"
                control={control}
                required
                error={errors?.certificateDate}
              />
              <InputNumber
                label="Dias otorgados"
                nameInput="certificateJustifiedDays"
                register={register}
                required
                error={errors?.certificateJustifiedDays}
              />

              <FileUpload
                label="Adjuntar certificado médico (Opcional)"
                updateFilesCb={updateUploadedFiles}
                maxFileSizeInBytes={500000}
                accept="image/x-png,image/jpeg"
                multiple
              />
            </ToggleSwitch>

            <ToggleSwitch
              label="El empleado esta cuidando a un familiar"
              onChange={() => {
                setValue("familyMemberInfo", undefined);
              }}
            >
              <Input
                type="text"
                label="Nombre del familiar y relación de parentezco"
                fieldName="familyMemberInfo"
                register={register}
                required
                error={errors?.familyMemberInfo}
              />
            </ToggleSwitch>


            <div className="flex items-center my-3">
              <InputRadio
                label="¿Cambiar dirección de Visita?"
                fieldName="not_at_home"
                option1="No"
                option2="Si"
                onChange={(e: any) => setIsNotAtHome(e)}
                register={register}
                defaultValue={'No'}
                error={errors?.not_at_home}
              />
            </div>

            {isNotAtHome === 'Si' && <>
              <AddressAutocomplete
                onSelectAddress={handleSelectAddress}
                type="text"
                label="Buscar dirección"
                fieldName="address"
                error={errors?.address}
                required
              />
              <Input
                type="text"
                label="Dirección completa (torre - piso - dpto agregar a lo último)"
                fieldName="address"
                register={register}
                required
                error={errors?.address}
                onChange={(e: React.ChangeEvent<HTMLInputElement>) =>
                  e.target.value.includes(",") &&
                  setValue("address", e.target.value.replace(/,/g, ""))
                }
                onBlur={clearInvalidAddressErrors}
              />
            </>}
          </>

        </StyledWrapper.FormContainer>
        <StyledWrapper.Footer>
          {/* <div className="cursor-pointer h-100" onClick={() => handleClose()}>
            <p className="border m-4 p-4 rounded-md hover:bg-slate-300">Volver</p>
          </div> */}
          <div className="w-100">
            <PrimaryButton
              type="submit"
              text="Solicitar"
              styles="bg-red-500 hover:bg-red-600 font-bold text-white"
              disabled={isLoading}
            />
          </div>
        </StyledWrapper.Footer>
      </form>

      {isActive(UPDATE_EMPLOYEE_DATA) && (
        <UpdateParcialEmployeeData
          show
          onClose={() => closeModal(UPDATE_EMPLOYEE_DATA)}
          urlTittle={UPDATE_EMPLOYEE_DATA}
          refreshFunction={handleCloseUpdatePhoneNumberModal}

        />
      )}
    </div>
  );
}
